"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobile_detect_1 = __importDefault(require("mobile-detect"));
var md = new mobile_detect_1.default(window.navigator.userAgent);
var classes = [md.mobile() ? 'mobile' : 'nonmobile', md.phone() ? 'phone' : 'tablet', md.userAgent()].join('-').toLowerCase().replace(/\s/g, '');
document.body.classList.add(classes);
